import type { CheckoutEvent } from "dodopayments-checkout";

type Sdk = typeof import("dodopayments-checkout").DodoPayments;
let loading: Promise<Sdk> | null = null;
let settle: ((completed: boolean) => void) | null = null;
let fail: (() => void) | null = null;

function eventReceived(event: CheckoutEvent) {
	if (event.event_type === "checkout.redirect_requested" || event.event_type === "checkout.closed") {
		const done = settle;
		settle = null;
		fail = null;
		done?.(event.event_type === "checkout.redirect_requested");
	} else if (event.event_type === "checkout.error" || event.event_type === "checkout.link_expired") {
		const reject = fail;
		settle = null;
		fail = null;
		reject?.();
	}
}

/** Keep Dodo's existing subscription rail while presenting its hosted form in place. */
export async function openSubscriptionCheckout(checkoutUrl: string, errorMessage: string): Promise<boolean> {
	const url = new URL(checkoutUrl);
	if (
		url.protocol !== "https:" ||
		!["checkout.dodopayments.com", "test.checkout.dodopayments.com"].includes(url.hostname)
	) {
		throw new Error(errorMessage);
	}
	loading ??= import("dodopayments-checkout")
		.then(({ DodoPayments }) => DodoPayments)
		.catch((error) => {
			loading = null;
			throw error;
		});
	const sdk = await loading;
	sdk.Initialize({
		mode: url.hostname.startsWith("test.") ? "test" : "live",
		displayType: "overlay",
		onEvent: eventReceived,
	});
	try {
		return await new Promise<boolean>((resolve, reject) => {
			settle = resolve;
			fail = () => reject(new Error(errorMessage));
			// The webhook, rather than a redirect or SDK event, confirms the plan.
			sdk.Checkout.open({ checkoutUrl, options: { manualRedirect: true } });
		});
	} finally {
		settle = null;
		fail = null;
		if (sdk.Checkout.isOpen()) sdk.Checkout.close();
	}
}
